/* BSG header — the behaviours Dawn does not already provide:
   1. hover-open for the desktop Shop dropdown (click, Escape, focus-out and the sticky
      header's closeMenuDisclosure() all stay Dawn's, via <header-menu>/<details>);
   2. the drawer's own close button and the focus move into the panel on open;
   3. a full drawer close when the drawer's loyalty link (data-candells-loyalty) is
      clicked, since Bloy's rewards-popup handler calls preventDefault() and nothing
      navigates to close it otherwise.

   Deliberately NOT a drawer implementation. global.js's MenuDrawer/HeaderDrawer owns
   open/close, the focus trap, --viewport-height and the body scroll lock.

   Close-button contract (do not "simplify" this away):
   MenuDrawer.bindEvents() attaches onCloseButtonClick to EVERY <button> inside
   <header-drawer>. That handler runs closeSubmenu() on the main <details> — a PARTIAL
   close: it drops .menu-opening and starts the 400ms closeAnimation, but leaves
   body.overflow-hidden-tablet and .section-header.menu-open in place. Our listener is
   attached later (global.js is deferred earlier in the document than this file), so it
   runs second, while [open] is still present, and calls summary.click() — which
   onSummaryClick sees as isOpen === true and turns into a full closeMenuDrawer().
   Removing our handler would leave the page scroll-locked after closing. */
(function () {
  var HOVER = window.matchMedia('(min-width: 900px) and (hover: hover) and (pointer: fine)');

  function bindDropdowns() {
    document.querySelectorAll('.candells-header-nav header-menu:not([data-candells-bound])').forEach(function (menu) {
      var details = menu.querySelector('details');
      if (!details) return;
      var summary = details.querySelector('summary');
      if (!summary) return;

      menu.dataset.candellsBound = '1';
      var timer;

      menu.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        if (!HOVER.matches) return;
        details.open = true;
        summary.setAttribute('aria-expanded', 'true');
      });

      /* The grace period stops the panel flickering shut when the pointer crosses the
         14px hover bridge (.candells-header-menu__panel padding-top). Runs on touch
         too, where mouseenter never fired, so it is a harmless no-op. */
      menu.addEventListener('mouseleave', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          details.open = false;
          summary.setAttribute('aria-expanded', 'false');
        }, 120);
      });
    });
  }

  function bindDrawer() {
    var drawer = document.querySelector('header-drawer:not([data-candells-bound])');
    if (!drawer) return;

    /* Placed ahead of the details/summary/close-button guards below so the loyalty link
       still closes the drawer even when one of those is missing. Bloy's rewards popup is a
       capture-phase document click listener that calls preventDefault() on a same-origin,
       same-pathname `#popup` link (see sections/header.liquid) — nothing navigates, so
       without this the drawer would stay open, scroll-locked, on top of the popup. Reuses
       summary.click() so the close goes through global.js's complete close path (focus trap
       + body scroll lock), the same as the close button below — see the contract note at
       the top of this file. Bound on its own data attribute, independent of
       drawer.dataset.candellsBound (set only once the close-button wiring succeeds further
       down), so a later init() re-run can't double-bind it. */
    var loyaltyLink = drawer.querySelector('[data-candells-loyalty]:not([data-candells-bound])');
    if (loyaltyLink) {
      loyaltyLink.dataset.candellsBound = '1';
      loyaltyLink.addEventListener('click', function () {
        var drawerSummary = drawer.querySelector('#Details-menu-drawer-container > summary');
        if (drawerSummary) drawerSummary.click();
      });
    }

    var details = drawer.querySelector('#Details-menu-drawer-container');
    if (!details) return;
    var summary = details.querySelector(':scope > summary');
    if (!summary) return;

    drawer.dataset.candellsBound = '1';
    var close = drawer.querySelector('.candells-drawer__close');
    if (!close) return;

    close.addEventListener('click', function () {
      summary.click();
    });

    /* Move focus off the (now covered) burger and into the panel. The 60ms wait is
       because .menu-opening — which flips the panel from visibility:hidden — is added
       inside a setTimeout in openMenuDrawer(); a hidden element cannot take focus.
       trapFocus's focusin guard ignores targets that are neither first nor last, so
       this does not fight the trap. */
    details.addEventListener('toggle', function () {
      if (!details.open) return;
      setTimeout(function () {
        close.focus();
      }, 60);
    });
  }

  function init() {
    bindDropdowns();
    bindDrawer();
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();
